import { Dispatch } from 'redux';
import * as MessageService from '~/services/message';
import LimitsApi from '~/repositories/limits';
import { GET_LIMITS, UPDATE_LIMIT_STATUS } from './actionTypes';
import { decreaseLoading, increaseLoading, LoadingAction } from './loading';
export type SetUserLimitsAction = {
  payload: bank.TransactionLimit[];
  type: string;
};

export const getAllLimits =
  () => async (dispatch: Dispatch<SetUserLimitsAction | LoadingAction>) => {
    dispatch(increaseLoading());
    try {
      const payload = await LimitsApi.getAllLimits();
      dispatch({
        type: GET_LIMITS,
        payload,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const updateLimit =
  (limit: bank.TransactionLimit, pin: string) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload = await LimitsApi.updateLimit(limit, pin);
      if (payload.status) {
        dispatch({
          type: UPDATE_LIMIT_STATUS,
          payload: payload.status,
        });
        dispatch(getAllLimits());
      }
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };
